module.exports = __webpack_public_path__ + "img/e47d53746adc713f417b12df816f7468.jpg";